import React from 'react';
import Modal from "react-modal";
import { useNavigate } from 'react-router-dom';
import { FaClock, FaSignOutAlt } from "react-icons/fa";

import styles from "./sessionTimeout.module.scss";


const SessionTimeoutPopup = ({ isVisible, onClose }) => {
    const navigate = useNavigate();

    const handleNavigateToAuth = () => {
        localStorage.removeItem("user");
        setTimeout(() => {
            onClose();
            navigate('/auth');
        }, 1000);
    };

    const sessionTimeoutPopupStyles = {
        content: {
            width: "90%",
            maxWidth: "420px",
            height: "auto",
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            border: "none",
            borderRadius: "20px",
            padding: "0",
            background: "transparent",
            boxShadow: "none",
            outline: "none",
            overflow: "hidden",
        },
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            backdropFilter: "blur(8px)",
            zIndex: 1000,
        }
    };

    return (
        <Modal
            isOpen={isVisible}
            onRequestClose={onClose}
            style={sessionTimeoutPopupStyles}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
        >
            <div className={styles.content}>
                <div className={styles.header}>
                    <div className={styles.icon}>
                        <FaClock />
                    </div>
                    <h3 className={styles.title}>Session Timeout</h3>
                    <p className={styles.message}>
                        Your session has expired due to inactivity. Please log in again to continue using the admin dashboard.
                    </p>
                </div>

                <div className="d-flex justify-content-center gap-3">
                    <button
                        className={styles.loginButton}
                        onClick={handleNavigateToAuth}
                    >
                        <FaSignOutAlt className={styles.loginIcon} />
                        Go to Login
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default SessionTimeoutPopup;
